export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"

export const CHECK_ACCOUNT = "CHECK_ACCOUNT"
export const CHECK_ACCOUNT_SUCCESSFUL = "CHECK_ACCOUNT_SUCCESSFUL"
export const CHECK_ACCOUNT_FAILED = "CHECK_ACCOUNT_FAILED"

